import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const WhyChooseUsEditor = () => {
  const [content, setContent] = useState({});
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/all`);
      const data = await response.json();
      if (data.success) {
        setContent(data.data.whyChooseUs || {});
        setItems(data.data.whyChooseUsItems || []);
      }
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/why-choose-us`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(content)
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ قسم لماذا تختارنا بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'خطأ في حفظ المحتوى');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>محرر لماذا تختارنا</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-grid">
        <div className="editor-column">
          <h3>المحتوى العربي</h3>
          <div className="editor-form-group">
            <label>العلامة</label>
            <input
              type="text"
              value={content.tag_ar || ''}
              onChange={(e) => setContent({...content, tag_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>العنوان</label>
            <textarea
              rows="2"
              value={content.title_ar || ''}
              onChange={(e) => setContent({...content, title_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>العنوان الفرعي</label>
            <textarea
              rows="3"
              value={content.subtitle_ar || ''}
              onChange={(e) => setContent({...content, subtitle_ar: e.target.value})}
            />
          </div>
        </div>

        <div className="editor-column">
          <h3>المحتوى الإنجليزي</h3>
          <div className="editor-form-group">
            <label>Tag (English)</label>
            <input
              type="text"
              value={content.tag_en || ''}
              onChange={(e) => setContent({...content, tag_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Title (English)</label>
            <textarea
              rows="2"
              value={content.title_en || ''}
              onChange={(e) => setContent({...content, title_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Subtitle (English)</label>
            <textarea
              rows="3"
              value={content.subtitle_en || ''}
              onChange={(e) => setContent({...content, subtitle_en: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="editor-form-group">
        <label>رابط صورة الخلفية</label>
        <div className="editor-image-input">
          <input
            type="text"
            value={content.background_image_url || ''}
            onChange={(e) => setContent({...content, background_image_url: e.target.value})}
            placeholder="رابط الصورة أو رفع ملف"
          />
        </div>
      </div>

      <h3 style={{ marginTop: '30px', marginBottom: '20px', color: '#815327' }}>عناصر لماذا تختارنا</h3>
      <div className="editor-items-list">
        {items.map((item) => (
          <div key={item.id} className="editor-item-card">
            <div className="editor-item-content">
              <h4>{item.title_ar} / {item.title_en}</h4>
              <p><strong>عربي:</strong> {item.description_ar}</p>
              <p><strong>إنجليزي:</strong> {item.description_en}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="editor-actions">
        <button className="editor-btn-save" onClick={handleSave} disabled={saving}>
          {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
        </button>
      </div>
    </div>
  );
};

export default WhyChooseUsEditor;

